import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'utils/hooks'
import AnnouncementForm, { SubmitDataProps } from 'components/authorised/Home/AnnouncementForm'
import { announcementsCreate } from 'redux/actions/announcementsActions'
import { getAllEmployeesLoad } from 'redux/actions/employeeActions'
import { businessUnitsLoad } from 'redux/actions/businessUnitActions'
import { listDepartmentsLoad } from 'redux/newDepartments/actionCreators'
import { locationsLoad } from 'redux/actions/filterActions'
import { Text, Modal, Flex, Button } from '@jisr-hr/design-system'
import { Button as DSButton, Icon } from '@jisr-hr/ds'

import I18n from 'translations/i18n'
import Styles from './styles.module.css'

const Announcement = (): JSX.Element => {
  const [openForm, setOpenForm] = useState<boolean>(false)
  const [disabled, setDisabled] = useState<boolean>(false)
  const dispatch = useDispatch()
  const { fetching } = useSelector(({ announcements }) => announcements)

  const onSubmit = (values: SubmitDataProps): void => {
    dispatch(announcementsCreate(values)).then(() => {
      setOpenForm(false)
    })
  }

  useEffect(() => {
    dispatch(getAllEmployeesLoad({ template: 'public' }))
    dispatch(locationsLoad({ template: 'public' }))
    dispatch(listDepartmentsLoad({ template: 'public' }))
    dispatch(businessUnitsLoad({ template: 'public' }))
  }, [])

  return (
    <div>
      <DSButton
        label={I18n.t('share_announcement')}
        testId="btn-showAnnouncement"
        size="sm"
        onClick={(): void => setOpenForm(true)}
        variant="tertiaryGray"
        iconLeading={<Icon name="send-01" />}
      />
      <Modal
        variant="centerDialog"
        isOpen={openForm}
        width={600}
        modalHeaderClassName={Styles.modalHeader}
        modalFooterClassName={Styles.modalFooter}
        onClose={(): void => setOpenForm(false)}
        header={
          <Text
            weight="bold"
            typography="title"
          >
            {I18n.t('share_announcement')}
          </Text>
        }
        content={
          <div className={Styles.modalContent}>
            <AnnouncementForm
              onSubmit={onSubmit}
              setDisabled={setDisabled}
            />
          </div>
        }
        footer={
          <Flex justifyEnd>
            <Button
              label={I18n.t('cancel')}
              onClick={(): void => setOpenForm(false)}
              size="medium"
              variant="secondary"
              style={{ marginInlineEnd: 5 }}
            />
            <Button
              data-testid="submit-showAnnouncement"
              form="announcement-form"
              type="submit"
              size="medium"
              variant="primary"
              label={I18n.t('share')}
              disabled={disabled || fetching}
            />
          </Flex>
        }
      />
    </div>
  )
}

export default Announcement
